export default __webpack_public_path__ + "static/media/Vesp_Icon.89a29d01.png";